import { compose, bindActionCreators  } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import dataFetcher from "../../parts/chore/dataFetcher";

import UserInbox from './UserInbox';

const mapStateToProps = state => ({
   session: state.session,
});

const mapDispatchToProps = dispatch => bindActionCreators({
 }, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  dataFetcher
)(UserInbox);